<template>
  <FKBreadCrumb :page="$t('page.edit')" :title="$t('page.create_edit_zone')">
    <FKBreadCrumbItem :page="$t('page.zones')" to="/zones" />
    <FKBreadCrumbItem :page="`${zone.name}`" :to="`/zones/${zone.id}`" />
  </FKBreadCrumb>
  <ZoneForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { Zone } from "@/utils/models/zone.model";
import ZoneForm from "@/components/FK/Zones/ZoneForm.vue";

export default defineComponent({
  name: "UpdateCenterPage",
  computed: {
    zone(): Zone { return this.$route.meta.zone as Zone },
  },
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    ZoneForm,
  },
});
</script>